import * as React from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router';
import Navigation from '../components/Navigation/Navigation';
import Footer from '../components/Footer';
import Dive from '../components/Dive';
import EditDive from '../components/EditDive';
import Dives from '../components/Dives';
import SharedDives from '../components/SharedDives';
import SharedDive from '../components/SharedDive';
import NewDive from '../components/NewDive';
import NewShareDive from '../components/NewShareDive';
import Settings from '../components/Settings/Settings';
import Contact from '../components/Contact';
import Logout from '../components/Logout';
import ErrorPage from '../components/ErrorPage';
import Dashboard from './Dashboard';
import PrivateRoute from '../components/PrivateRoute';

export interface IAppProps extends RouteComponentProps<{}> {}

class App extends React.Component<IAppProps> {
    render() {
        const { match } = this.props;
        return (
            <div>
                <Navigation baseUrl={match.url} />

                <main className="cf">
                    <Switch>
                        <PrivateRoute
                            exact
                            path={`${match.url}/`}
                            component={Dashboard}
                        />
                        <PrivateRoute
                            exact
                            path={`${match.url}/dives`}
                            component={Dives}
                        />
                        <PrivateRoute
                            exact
                            path={`${match.url}/shared-dives`}
                            component={SharedDives}
                        />
                        <PrivateRoute
                            path={`${match.url}/dive/edit/:diveId`}
                            component={EditDive}
                        />
                        <PrivateRoute
                            path={`${match.url}/dives/:diveId`}
                            component={Dive}
                        />
                        <PrivateRoute
                            path={`${match.url}/shared-dive/:diveId`}
                            component={SharedDive}
                        />
                        <PrivateRoute
                            path={`${match.url}/new-dive`}
                            component={NewDive}
                        />
                        <PrivateRoute
                            path={`${match.url}/add-shared-dive/:tokenId`}
                            component={NewShareDive}
                        />
                        <PrivateRoute
                            path={`${match.url}/settings`}
                            component={Settings}
                        />
                        <PrivateRoute
                            path={`${match.url}/contact`}
                            component={Contact}
                        />
                        <PrivateRoute
                            path={`${match.url}/logout`}
                            component={Logout}
                        />
                        <Route component={ErrorPage} />
                    </Switch>
                </main>

                <Footer logged={true} />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/App.tsx